module.exports = __webpack_public_path__ + "static/img/无数据.7fe73ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/无数据.png
// module id = g4Ia
// module chunks = 1